import { Dialog, Button, Stack, Text, Box, Center } from '@chakra-ui/react';
import { ForbidAddIcon } from '@halo/ui-chat-react';
import dayjs from 'dayjs';

export function ForbidAddDialog({
  isOpen,
  setIsOpen,
  endTime,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  endTime: number;
}) {
  const { t } = useTranslation();
  const formattedEndTime = useMemo(() => {
    return dayjs(endTime).format('MMM D, YYYY, HH:mm');
  }, [endTime]);
  return (
    <Dialog.Root
      placement="center"
      open={isOpen}
      onOpenChange={(details) => setIsOpen(details.open)}
      unmountOnExit
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content bg="bg.subtle" rounded="2xl" width="477px">
          <Dialog.Header></Dialog.Header>
          <Dialog.Body px="5" py="0">
            <Stack direction="column" alignItems="center" justifyContent="center" gap="4">
              <Box w="100px" h="100px">
                <ForbidAddIcon />
              </Box>
              <Text fontSize="xl" fontWeight="semibold" color="fg">
                {t('chat.forbidAddTitle')}
              </Text>
              <Box
                p="4"
                bg="bg"
                rounded="lg"
                fontSize="sm"
                fontWeight="medium"
                color="fg"
                lineHeight="normal"
                w="full"
              >
                {t('chat.forbidAddDesc', { time: `(${formattedEndTime})` })}
              </Box>
            </Stack>
          </Dialog.Body>
          <Dialog.Footer px="5" mt="8">
            <Center w="full">
              <Button minW="162px" rounded="xl" onClick={() => setIsOpen(false)}>
                {t('buttons.confirm')}
              </Button>
            </Center>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
